export const DetailColumns = [
  [],
  [
    {
      title: <div className="table-title">評価基準</div>,
      dataIndex: "evaluationCriteria",
      key: "evaluationCriteria",
      width: "55%",
      render: (text, record) => (
        <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {text}
        </div>
      ),
    },
    {
      title: <div className="table-title">評価例</div>,
      dataIndex: "evaluationExample",
      key: "evaluationExample",
      width: "40%",
      render: (text, record) => (
        <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {text}
        </div>
      ),
    },
    {
      title: <div className="table-title">評価点</div>,
      dataIndex: "highScore",
      key: "highScore",
      width: "5%",
    },
  ],
  [
    {
      title: <div className="table-title">面接評価項目</div>,
      dataIndex: "evaluationCriteria",
      key: "evaluationCriteria",
      width: "55%",
      render: (text, record) => (
        <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {text}
        </div>
      ),
    },
    {
      title: <div className="table-title">最低点</div>,
      dataIndex: "lowScore",
      key: "lowScore",
      width: "10%",
    },
    {
      title: <div className="table-title">最高点</div>,
      dataIndex: "highScore",
      key: "highScore",
      width: "10%",
    },
  ],
  [
    {
      title: <div className="table-title">評価内容</div>,
      dataIndex: "evaluationCriteria",
      key: "evaluationCriteria",
      width: "55%",
      render: (text, record) => (
        <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {text}
        </div>
      ),
    },
    {
      title: <div className="table-title">最低点</div>,
      dataIndex: "lowScore",
      key: "lowScore",
      width: "10%",
    },
    {
      title: <div className="table-title">最高点</div>,
      dataIndex: "highScore",
      key: "highScore",
      width: "10%",
    },
  ],
  [
    {
      title: <div className="table-title">最低点</div>,
      dataIndex: "lowScore",
      key: "lowScore",
      width: "10%",
    },
    {
      title: <div className="table-title">最高点</div>,
      dataIndex: "highScore",
      key: "highScore",
      width: "10%",
    },
  ],
  [
    {
      title: <div className="table-title">質問</div>,
      dataIndex: "evaluationCriteria",
      key: "evaluationCriteria",
      width: "55%",
      render: (text, record) => (
        <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {text}
        </div>
      ),
    },
    {
      title: <div className="table-title">最低点</div>,
      dataIndex: "lowScore",
      key: "lowScore",
      width: "10%",
    },
    {
      title: <div className="table-title">最高点</div>,
      dataIndex: "highScore",
      key: "highScore",
      width: "10%",
    },
  ],
  [
    {
      title: <div className="table-title">最低点</div>,
      dataIndex: "lowScore",
      key: "lowScore",
      width: "10%",
    },
    {
      title: <div className="table-title">最高点</div>,
      dataIndex: "highScore",
      key: "highScore",
      width: "10%",
    },
  ],
  [
    {
      title: <div className="table-title">最低点</div>,
      dataIndex: "lowScore",
      key: "lowScore",
      width: "10%",
    },
    {
      title: <div className="table-title">最高点</div>,
      dataIndex: "highScore",
      key: "highScore",
      width: "10%",
    },
  ],
  [
    {
      title: <div className="table-title">質問</div>,
      dataIndex: "evaluationCriteria",
      key: "evaluationCriteria",
      width: "55%",
      render: (text, record) => (
        <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {text}
        </div>
      ),
    },
  ],
  [
    {
      title: <div className="table-title">質問</div>,
      dataIndex: "evaluationCriteria",
      key: "evaluationCriteria",
      width: "55%",
      render: (text, record) => (
        <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
          {text}
        </div>
      ),
    },
    {
      title: <div className="table-title">最低点</div>,
      dataIndex: "lowScore",
      key: "lowScore",
      width: "10%",
    },
    {
      title: <div className="table-title">最高点</div>,
      dataIndex: "highScore",
      key: "highScore",
      width: "10%",
    },
  ],
];
